import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { CreditLayout } from "../../common/Layouts";
let transportCarrier = null;
function CreditTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    transportCarrier = props.formFields.R_TRANSPORTCARRIER;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const onFormLoad = useCallback(() => {
       props.creditFormLookupsLoad(formRefs);
    });
  const handleFieldChange = useCallback((name, value) => {
    });
    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    useEffect(()=>{
        if(props.formFields.ROWID == "00000000-0000-0000-0000-000000000000"){
            props.setformFields(prevFields => ({
                ...prevFields,
                CustomerCREDITSTATUSFLAG:'N'
        }));
        }
    },[props.formFields.ROWID])
    return (
        <div className="FormMt">
            <FormField
            currrentUser={currentUser}
            layoutId='D2764063-8BBC-4F62-A5BF-057A55426B1D'
            layoutName='CreditForm'
            defaultFormSchema={CreditLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            onFormLoad={onFormLoad}
            handleFieldValueChange={handleFieldChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
        />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CreditTab);